import { render, staticRenderFns } from "./ConfigurarTimbres.vue?vue&type=template&id=0976f349&scoped=true"
import script from "./ConfigurarTimbres.vue?vue&type=script&lang=js"
export * from "./ConfigurarTimbres.vue?vue&type=script&lang=js"
import style0 from "./ConfigurarTimbres.vue?vue&type=style&index=0&id=0976f349&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0976f349",
  null
  
)

export default component.exports